import Async from "components/DesignSystem/AsyncComponents/Async";
import { useCurrentEntityId } from "hooks/useCurrentEntityId";
import { EmptyScreen } from "pages/Books/EmptyScreen";
import { useEffect, useRef, useState } from "react";
import {
  useGetAllCompliancesByGroupQuery,
  useGetComplianceOverviewQuery,
} from "store/apis/calendar";
import { useCurrentGroupContext } from "hooks/useCurrentGroupContext";
import { DeadlineFilterType } from "../DeadlineFilter";
import { DeadlineCard } from "./Deadlines/DeadlineCard";

export const NewCompliance = ({
  filterValue,
}: {
  filterValue: DeadlineFilterType;
}) => {
  const [silderAccordionValue, setSilderAccordionValue] =
    useState<string>("CURRENT");
  const currentDeadlineRef = useRef<HTMLSpanElement>(null);
  const pastDeadlineRef = useRef<HTMLSpanElement>(null);
  const entityId = useCurrentEntityId();

  const {
    data,
    isLoading: isGetting,
    isSuccess: isOverviewSuccess,
  } = useGetComplianceOverviewQuery(
    {
      entityId,
    },
    { skip: !entityId, refetchOnMountOrArgChange: true }
  );

  const { uuid: groupId } = useCurrentGroupContext();

  const {
    data: deadlines,
    isLoading,
    isSuccess,
    isFetching,
  } = useGetAllCompliancesByGroupQuery(
    {
      groupId,
      status: filterValue.STATUS?.join(","),
      entityId: filterValue.ENTITY?.join(","),
    },
    { skip: !groupId, refetchOnMountOrArgChange: true }
  );

  const pastDeadlineCount = deadlines?.historical_alarms.length;
  const currentDeadlineCount = deadlines?.current_alarms.length;

  useEffect(() => {
    if (
      (!pastDeadlineCount || pastDeadlineCount === 0) &&
      (!currentDeadlineCount || currentDeadlineCount === 0) &&
      isSuccess
    ) {
      setSilderAccordionValue("");
    }
  }, [pastDeadlineCount, currentDeadlineCount, isSuccess]);

  useEffect(() => {
    if (silderAccordionValue === "CURRENT") {
      currentDeadlineRef?.current?.scrollIntoView({ behavior: "smooth" });
    }

    if (silderAccordionValue === "PAST") {
      pastDeadlineRef?.current?.scrollIntoView({ behavior: "smooth" });
    }
  }, [silderAccordionValue]);

  return (
    <Async.Root
      {...{
        isEmpty: Boolean(
          deadlines &&
            deadlines.current_alarms.length === 0 &&
            deadlines.historical_alarms.length === 0 &&
            !data
        ),
        isLoading: isLoading || isGetting || isFetching,
        isSuccess: isSuccess || isOverviewSuccess,
      }}
    >
      <Async.Empty>
        <EmptyScreen text="No data available" />
      </Async.Empty>
      <Async.Success>
        <div className="t-flex t-gap-4 t-flex-col t-pb-24">
          {deadlines?.current_alarms &&
            deadlines.current_alarms.map((alarm) => (
              <DeadlineCard deadlineData={alarm} key={alarm.uuid} />
            ))}
        </div>
      </Async.Success>
    </Async.Root>
  );
};
